/* eslint-disable react/jsx-filename-extension */
import React, {
  useState, useCallback, useEffect, useRef,
} from 'react';
import {
  collection, query, onSnapshot,
} from 'firebase/firestore';
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { db } from './firebase';

export default function LayOffDataTable() {
  const [layOffData, setLayoffData] = useState([]);
  const gridRef = useRef();
  /* function to get all tasks from firestore in realtime */
  useEffect(() => {
    const taskColRef = query(collection(db, 'layoff_data'));
    onSnapshot(taskColRef, (snapshot) => {
      setLayoffData(snapshot.docs.map((doc) => (
        doc.data()
      )));
    });
  }, []);

  const onGridReady = useCallback(() => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const [columnDefs] = useState([
    { field: 'companyName' },
    { field: 'fullName' },
    { field: 'email' },
    { field: 'linkedIn' },
    { field: 'twitter' },

  ]);
  return (
    <div style={{ height: 'calc(100vh - 25vh)', width: '100vh' }} className="ag-theme-alpine">
      <AgGridReact
        ref={gridRef}
        rowData={layOffData}
        onGridReady={onGridReady}
        columnDefs={columnDefs}
      />
    </div>

  );
}
